"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbInlineMessageIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-components.sb-inline-messages.sb-inline-message-icon
 */
var getIconClass = function getIconClass(type) {
  return {
    'sbi-help-info color-info': type === _constants.INLINE_MESSAGE_TYPE_INFO,
    'sbi-alert color-error': type === _constants.INLINE_MESSAGE_TYPE_ERROR,
    'sbi-alert color-warning': type === _constants.INLINE_MESSAGE_TYPE_WARNING,
    'sbi-alert color-desc': type === _constants.INLINE_MESSAGE_TYPE_DESC
  };
};
/**
 * @typedef {Object} skybase-components.sb-inline-messages.sb-inline-message-icon#props
 *
 * @property {skybase-components.sb-inline-messages.constants#type} type=INFO
 */

/**
 * @description
 * It is an icon comonent. The render dependends on {@link skybase-components.sb-inline-messages.constants#type}
 * @function
 *
 * @name skybase-components.sb-inline-messages.sb-inline-message-icon#SbInlineMessageIcon
 * @param  {skybase-components.sb-inline-messages.sb-inline-message-icon#props} props - The key-value pairs.
 * @return {Array<React.Component>}
 */


var SbInlineMessageIcon = function SbInlineMessageIcon(props) {
  var type = props.type;
  return /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)('sb-inline-message-icon', getIconClass(type))
  });
};

exports.SbInlineMessageIcon = SbInlineMessageIcon;
SbInlineMessageIcon.propTypes = {
  type: _propTypes.default.string
};
SbInlineMessageIcon.defaultProps = {
  type: _constants.INLINE_MESSAGE_TYPE_WARNING
};
//# sourceMappingURL=sb-inline-message-icon.js.map